// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"243":"701e46be","322":"a87ae76a","787":"3fd2d004"}[chunkId] + ".chunk.js";
};